import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import HeroFlyer from '../components/HeroFlyer';
import { BRAND_ASSETS } from '../brand/assets';

const Landing: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="container"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15 }}
      >
        <HeroFlyer showFlyerImage={false}>
          <img
            src={BRAND_ASSETS.logoCosmic}
            alt="WisemenResearch"
            className="landing-brand-mark"
          />
          <h1
            style={{
              fontSize: 'clamp(1.75rem, 4vw, 2.75rem)',
              marginBottom: '16px',
              color: 'var(--neon-cyan)',
              textShadow: 'var(--glow-cyan)',
            }}
          >
            Research the future of mental health
          </h1>
          <p
            style={{
              fontSize: '1.15rem',
              color: 'var(--text-secondary)',
              maxWidth: '640px',
              margin: '0 auto 28px',
              lineHeight: 1.6,
            }}
          >
            Wisemen Research Group connects volunteers, researchers, and open datasets
            exploring consciousness, psychedelics, and neuroplasticity.
          </p>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '12px',
              justifyContent: 'center',
            }}
          >
            <Link to="/register" className="btn btn-primary">
              Join the community
            </Link>
            <Link to="/login" className="btn btn-secondary">
              Member sign in
            </Link>
            <Link
              to="/about"
              className="btn btn-secondary"
              style={{ borderColor: 'rgba(232, 184, 75, 0.4)' }}
            >
              Learn more
            </Link>
          </div>
        </HeroFlyer>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35 }}
        className="card"
        style={{ marginTop: '30px', marginBottom: '50px' }}
      >
        <h2
          style={{
            textAlign: 'center',
            color: 'var(--neon-magenta)',
            textShadow: 'var(--glow-magenta)',
            marginBottom: '20px',
          }}
        >
          Member tools
        </h2>
        <p
          style={{
            textAlign: 'center',
            color: 'var(--text-secondary)',
            maxWidth: '720px',
            margin: '0 auto',
            lineHeight: 1.6,
          }}
        >
          Sign in to consult The Three Wisemen, browse the peer-reviewed library, community
          forums, marketplace, and membership options. Use the navigation above to explore
          each area after you create an account.
        </p>
      </motion.div>
    </motion.div>
  );
};

export default Landing;
